import React, { useState, useMemo, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button, List, ListItem } from '@mui/material';
import { useSelector } from 'react-redux';
import { movetask,ConverSubTask } from "../../store/grupo.actions";
import { grupoService } from "../../services/grupo.service";

export function SelectModal({ open, onClose, onSelect, taskIds,actionM }) {
    const boards = useSelector(storeState => storeState.boardModule.boards);
    const currentBoard = useSelector(storeState => storeState.boardModule.currentBoard);

    const [selectedType, setSelectedType] = useState('groups'); // Default to 'groups'
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedItem, setSelectedItem] = useState('');
    const [groups, setGroups] = useState([]);
    const [filteredBoards, setFilteredBoards] = useState(boards);
    const [hasSelectedBoard, setHasSelectedBoard] = useState(false); // Estado para rastrear si se seleccionó "Mover a Tablero"

    const allGrupos = 'grupos/listar';

    const fetchGroupsByBoard = async (boardId) => {
        try {
            const groupsData = await grupoService.getGroupsWithParams(allGrupos, { idtablero: boardId });
            setGroups(groupsData);
            setSelectedItem('');
        } catch (error) {
            console.error('Error fetching groups:', error);
        }
    };

    useEffect(() => {
        if (currentBoard) {
            fetchGroupsByBoard(currentBoard.id_tablero);
        }
    }, [currentBoard]);

    const handleSelectType = (type) => {
        setSelectedType(type);
        setSearchTerm('');
        setSelectedItem('');
        if (type === 'groups' && currentBoard) {
            fetchGroupsByBoard(currentBoard.id_tablero);
        } else {
            setFilteredBoards(boards);
        }
        if (type === 'boards') {
            setHasSelectedBoard(true);
        }
    };

    const filteredItems = useMemo(() => {
        const items = selectedType === 'groups' ? groups : filteredBoards;
        return items.filter(item =>
            (selectedType === 'groups' ? item.nombre_grupo : item.nombre_tablero)
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
        );
    }, [selectedType, searchTerm, groups, filteredBoards]);

    const handleSelectChange = (event) => {
        const selectedId = event.target.value;
        setSelectedItem(selectedId);
        const selected = filteredItems.find(item => item.id_grupo === selectedId || item.id_tablero === selectedId);
        onSelect(selected);
    };

    const handleItemClick = async (item) => {
        setSelectedItem(item.id_grupo || item.id_tablero);

        if (selectedType === 'groups'&& actionM ==="GroupPreview") {
            //funcion para mover tareas entre grupos
            await movetask(item.id_grupo, taskIds);
            onClose(); // Cierra el modal solo si se selecciona un grupo
            onSelect(item);
        }else if(selectedType === 'groups'&& actionM ==="SubGroupPreview"){ //Funcion para convertir subactividades en actividades
            await ConverSubTask(item.id_grupo, taskIds);
            onClose(); // Cierra el modal solo si se selecciona un grupo
            onSelect(item);
        }
        else {
            // Actualiza la lista de grupos cuando se seleccione un tablero


            await fetchGroupsByBoard(item.id_tablero);
            // Cambia el tipo seleccionado a 'groups' para mostrar los grupos
            setSelectedType('groups');
            // Limpia el campo de búsqueda y el item seleccionado
            setSearchTerm('');
            setSelectedItem('');
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '20%',
                    left: '30%',
                    width: '40%',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    padding: '16px',
                    boxShadow: 24,
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6">
                        Seleccionar {selectedType === 'groups' ? 'Grupo' : 'Tablero'}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {hasSelectedBoard && (
                            <Button
                                variant="outlined"
                                onClick={() => handleSelectType('groups')}
                                sx={{ textTransform: 'none' }}
                            >
                                Tablero Actual
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            onClick={() => handleSelectType('boards')}
                            sx={{ textTransform: 'none' }}
                        >
                            Mover a Tablero
                        </Button>
                    </Box>
                </Box>
                <TextField
                    sx={{ mb: 2 }}
                    label={`Buscar ${selectedType === 'groups' ? 'Grupo' : 'Tablero'}`}
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />

                <Box sx={{ mt: 2 }}>
                    <List sx={{ maxHeight: 200, overflow: 'auto', backgroundColor: '#f9f9f9' }}>
                        {filteredItems.map(item => (
                            <ListItem
                                key={item.id_grupo || item.id_tablero}
                                button
                                sx={{
                                    backgroundColor: 'white',
                                    color: 'black',
                                    mb: 1,
                                    borderLeft: `15px solid ${item.color}`, // Aplica el color de borde
                                }}
                                onClick={() => handleItemClick(item)}
                            >
                                {selectedType === 'groups' ? item.nombre_grupo : item.nombre_tablero}
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Box>
        </Modal>
    );
}
